module.exports = __webpack_public_path__ + "static/img/alipay-yajin.59ef3be9.png";